import { render } from "./UpdateResourceModal.vue?vue&type=template&id=455973bf"
import script from "./UpdateResourceModal.vue?vue&type=script&lang=js"
export * from "./UpdateResourceModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"UpdateResourceModal.vue"]])

export default __exports__